import React from 'react';

export default function TreasureMap({ stops, currentStop, solvedStops, onStopClick }) {
  return (
    <div className="treasure-map">
      {/* SVG dashed trail connecting stops */}
      <svg className="map-trails" viewBox="0 0 100 100" preserveAspectRatio="none">
        {stops.map((stop, i) => {
          if (i === 0) return null;
          const prev = stops[i - 1];
          const isSolved = solvedStops.includes(i - 1);
          return (
            <line
              key={`trail-${i}`}
              x1={prev.x}
              y1={prev.y}
              x2={stop.x}
              y2={stop.y}
              className={`map-trail ${isSolved ? 'trail-active' : 'trail-inactive'}`}
            />
          );
        })}
      </svg>

      {/* Map decorative elements */}
      <div className="map-deco map-deco-ocean">
        <span>🌊</span><span>🌊</span><span>🌊</span>
      </div>
      <div className="map-deco map-deco-palms" style={{ left: '5%', top: '20%' }}>🌴🌴</div>
      <div className="map-deco map-deco-palms" style={{ left: '60%', top: '15%' }}>🌴</div>
      <div className="map-deco map-deco-palms" style={{ right: '8%', top: '60%' }}>🌴</div>
      <div className="map-deco map-deco-stars" style={{ left: '45%', top: '5%' }}>⭐✨⭐</div>
      <div className="map-deco map-deco-hills" style={{ left: '70%', top: '3%' }}>⛰️</div>
      <div className="map-deco map-deco-clouds" style={{ left: '30%', top: '2%' }}>☁️</div>
      <div className="map-deco map-deco-clouds" style={{ right: '15%', top: '8%' }}>☁️</div>
      <div className="map-compass">🧭</div>

      {/* Stop markers */}
      {stops.map((stop, i) => {
        const isSolved = solvedStops.includes(i);
        const isActive = i === currentStop && !isSolved;
        const isLocked = i > currentStop;

        return (
          <button
            key={stop.id}
            className={`map-stop ${isSolved ? 'stop-solved' : ''} ${isActive ? 'stop-active' : ''} ${isLocked ? 'stop-locked' : ''}`}
            style={{ left: `${stop.x}%`, top: `${stop.y}%` }}
            onClick={() => onStopClick(i)}
            disabled={isLocked}
            title={isSolved ? stop.name : isActive ? 'Click to solve!' : '???'}
          >
            <span className="stop-icon">
              {isSolved ? '✅' : isActive ? stop.icon : '🔒'}
            </span>
            <span className="stop-label">
              {isSolved ? stop.name : isActive ? '???' : '???'}
            </span>
          </button>
        );
      })}
    </div>
  );
}
